import { render, staticRenderFns } from "./UserControl.vue?vue&type=template&id=a235b21a&scoped=true&"
import script from "./UserControl.vue?vue&type=script&lang=js&"
export * from "./UserControl.vue?vue&type=script&lang=js&"
import style0 from "./UserControl.vue?vue&type=style&index=0&id=a235b21a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a235b21a",
  null
  
)

export default component.exports